// extracted by mini-css-extract-plugin
export default {"displayBox":"DisplayBox_displayBox__YTb1P","children":"DisplayBox_children__MkTFg","header":"DisplayBox_header__s+Y4t"};